export default __webpack_public_path__ + "static/media/Pizza.65344410.jpg";